import { create } from "zustand";

interface MessengerState {
	pusherConnected: boolean;
	pusherChannelName: string | null;
}

interface MessengerActions {
	setPusherConnected: (connected: boolean) => void;
	setPusherChannelName: (channelName: string | null) => void;
	reset: () => void;
}

const initialState: MessengerState = {
	pusherConnected: false,
	pusherChannelName: null,
};

export const useMessengerStore = create<MessengerState & MessengerActions>()((set) => ({
	...initialState,
	setPusherConnected: (connected) => set({ pusherConnected: connected }),
	setPusherChannelName: (channelName) => set({ pusherChannelName: channelName }),
	reset: () => set(initialState),
}));
